import React, { useState, useEffect } from "react";
import "./pdf-viewer.css";
import { useLanguage } from "../contexts/LanguageContext";

const PdfViewer = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { isArabic } = useLanguage();

    // Check for URL parameter to auto-open PDF
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const openPdfParam = searchParams.get('openPdf');

        if (openPdfParam === 'true') {
            // Open the PDF modal
            openModal();

            // Clean up URL by removing the parameter
            searchParams.delete('openPdf');
            const newUrl = window.location.pathname +
                (searchParams.toString() ? '?' + searchParams.toString() : '') +
                window.location.hash;
            window.history.replaceState({}, '', newUrl);
        }
    }, []);

    const translations = {
        openButton: isArabic ? "عرض كتيب VIP" : "View VIP Brochure",
        closeButton: isArabic ? "إغلاق" : "Close"
    };

    const openModal = () => {
        setIsOpen(true);
        document.body.style.overflow = "hidden";
    };

    const closeModal = () => {
        setIsOpen(false);
        document.body.style.overflow = "unset";
    };

    const pdfUrl = `${window.location.origin}/docs/Freakyard_VIP_Brochure.pdf`;
    const viewerUrl = `/pdfjs/web/viewer.html?file=${encodeURIComponent(pdfUrl)}`;

    return (
        <>
            <div className="pdf-button-container">
                <button className="pdf-open-button" onClick={openModal}>
                    {translations.openButton}
                </button>
            </div>

            {isOpen && (
                <div className="pdf-modal-backdrop" onClick={closeModal}>
                    <div className="pdf-modal-container" onClick={(e) => e.stopPropagation()}>
                        <div className="pdf-modal-header">
                            <h2 className="pdf-modal-title">
                                {isArabic ? "كتيب VIP" : "VIP Brochure"}
                            </h2>
                            <button className="pdf-close-button" onClick={closeModal}>
                                {translations.closeButton}
                            </button>
                        </div>
                        <div className="pdf-iframe-wrapper">
                            <iframe
                                src={viewerUrl}
                                title="VIP Brochure"
                                className="pdf-iframe"
                                allow="fullscreen"
                            />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PdfViewer;